export default __webpack_public_path__ + "static/media/peer_infrastructure_vertical.26df0e9b.mp4";